import { render, staticRenderFns } from "./FCCCompetitionCategories.vue?vue&type=template&id=086c9828"
import script from "./FCCCompetitionCategories.vue?vue&type=script&lang=js"
export * from "./FCCCompetitionCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports